module.exports = __webpack_public_path__ + "static/media/ic_sensor_active.8520316a.png";